import { z } from "zod";

export const locationSchema = z.object({
	packStation: z.string().nullish(),
	machine: z.string().nullish(),
	machineGroup: z.string().nullish(),
	productionGroup: z.string().nullish(),
	pickZone: z.string().nullish(),
});

export type Location = z.infer<typeof locationSchema>;
